import { render, staticRenderFns } from "./AiContextChipList.vue?vue&type=template&id=2d5aaf63&scoped=true"
import script from "./AiContextChipList.vue?vue&type=script&lang=js"
export * from "./AiContextChipList.vue?vue&type=script&lang=js"
import style0 from "./AiContextChipList.vue?vue&type=style&index=0&id=2d5aaf63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5aaf63",
  null
  
)

export default component.exports